import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import AppRoutes from "./routes/AppRoutes";
import { BackgroundProvider } from "./features/backgrounds/BackgroundProvider";
import { ThemeProvider } from "./theme/ThemeProvider";
import ErrorBoundary from "./components/ErrorBoundary";
import { ConfirmHost } from "./components/em/confirm";

import "./features/backgrounds/backgrounds.css";
import "./features/dashboard/dashboard.css";
import "./motion/intro.css";

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <BackgroundProvider>
          <BrowserRouter>
            <AppRoutes />
            {/* Mount point for every toast.* call in the app. Without this,
                sonner renders nothing — the calls are silent no-ops. */}
            <Toaster
              position="top-right"
              richColors
              closeButton
              toastOptions={{ style: { fontSize: 13 } }}
            />
            {/* Mount point for every confirmDialog() call. Without this the
                helper falls back to window.confirm, which is what it is
                replacing. */}
            <ConfirmHost />
          </BrowserRouter>
        </BackgroundProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
